import { ApolloClient } from "@apollo/client";
import createRefdataApi from "../createRefdataApi";
import { AvailableRolesQuery, AvailableRolesDocument } from "./query.generated";

async function fetcher(client: ApolloClient<any>) {
  const result = await client.query<AvailableRolesQuery>({
    query: AvailableRolesDocument,
  });

  return result.data?.employees?.roles as string[];
}

const api = createRefdataApi(fetcher, "company role");

export const CompanyRoleRefdataContext = api.Provider;
export const useCompanyRolesAsync = api.useDataAsync;
export const useCompanyRoles = api.useData;
